import * as React from "react";
import { IOWidget, mk_widget, option, Options, Unit, Widget } from "../widget";

interface AnyProps<i,o> {
  input:i
  widgets:IOWidget<i,o>[]
  on_done:(output:o) => void
  options?:Options
}

interface AnyState<_i,_o> {}

/**
 * @deprecated Don't use directly, use the [[any]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
class Any<i,o> extends React.Component<AnyProps<i,o>, AnyState<i,o>> {
  constructor(props:AnyProps<i,o>, context:any) {
    super(props, context)
  }

  render() {
    return <React.Fragment>
      {this.props.widgets.map(widget =>
        widget(this.props.input).run(output => this.props.on_done(output)),
      )}
    </React.Fragment>
  }
}

/** 
 * This is the lifted functorial version of [[any]]
 * This means instead of operating on array of widgets, it operates on array of iowidgets
 */
export const any_io = function<i,o>(options?:Options) : (widgets:IOWidget<i,o>[]) =>
  IOWidget<i,o> {
  return widgets => (input:i) => mk_widget({
    run:(on_done:(outputs:o) => void) =>
      <Any options={options} on_done={on_done} widgets={widgets} input={input} key={option("key", options)} />
  })
}

/** 
 * Takes as input an array of widgets and propagates the result of
 * the first one that fires.
 * NOTE: All inputted widgets must have the same output type. In case,
 * a widget does not have a compatible type, you can use [[map]] to turn
 * its output type to a compatible one of `o`. A particularly easy to use
 * behaviour is to use [[never]] instead of mapping it.
 * @typeparam o the result type of any
 */
export const any = function<o>(options?:Options) : (widgets:Widget<o>[]) => Widget<o> {
  return widgets => any_io<Unit,o>(options)(widgets.map(w => (_:Unit) => w))({})
}
